// frontend/src/pages/maintenance/MaintenanceApp.tsx

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MaintenanceDashboard from './MaintenanceDashboard';
import ContractDetail from './ContractDetail';
import AppointmentDetail from './AppointmentDetail';
import ContractTemplatesList from './ContractTemplatesList';
import MaintenanceSettings from './MaintenanceSettings';

/**
 * Main router component for the Maintenance module.
 * Handles all maintenance-related routes.
 */
const MaintenanceApp: React.FC = () => {
  return (
    <Routes>
      {/* Default redirect to contracts */}
      <Route index element={<Navigate to="contracts" replace />} />

      {/* Contracts and Appointments - both use dashboard with tabs */}
      <Route path="contracts" element={<MaintenanceDashboard />} />
      <Route path="appointments" element={<MaintenanceDashboard />} />

      {/* Contract Detail */}
      <Route path="contracts/:id" element={<ContractDetail />} />

      {/* Appointment Detail */}
      <Route path="appointments/:id" element={<AppointmentDetail />} />

      {/* Templates */}
      <Route path="templates" element={<ContractTemplatesList />} />

      {/* Settings */}
      <Route path="settings" element={<MaintenanceSettings />} />
    </Routes>
  );
};

export default MaintenanceApp;
